import { ValidatorService, EvalidatorRequire } from '../services/validator.service';
import { CustomerModel } from './customer.model';
import { LetterService } from '../services/letter.service';

export class LetterModel {

    private _customer: CustomerModel;
    private _line1: string = '';
    private _line2: string = '';
    private _line3: string = '';
    private _line4: string = '';
    private _file: any = null;
    private _price: string = '3.00';
    private _speed:boolean = true;
    private _errors: any[];

    //*************************************
    //************ CONSTRUCTOR ************
    //*************************************
    constructor(public letterService: LetterService) {

    };

    //*************************************
    //*************** ACTION **************
    //*************************************
    public calculatePrice(){
        if (this.speed)
            this.price = '3.00';
        else
            this.price = '2.75';
    }

    public send(){
        if (this.validate())
            this.letterService.send(this);
    }

    modelChange(){

    }

    //*************************************
    //************* VALIDATOR *************
    //*************************************
    public validate(): boolean {
        let validator = new ValidatorService();
        validator
            .addField(this._line1, 'line1', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 5, max: 42}}
            ])
            .addField(this._line2, 'line2', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 2, max: 42}}
            ])
            .addField(this._line3, 'line3', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 7, max: 42}}
            ])
            .addField(this._line4, 'line4', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 2, max: 42}}
            ])
            .addField(this._file, 'file', EvalidatorRequire.Require, [
                {fn: validator.file, options: {size: 4000000, type: 'application/pdf'}}
            ]);
        this._errors = validator.run();
        return (this._errors == null);
    }

    //*************************************
    //************** METHOD ***************
    //*************************************


    //*************************************
    //********** GETTER / SETTER **********
    //*************************************

    get customer(): CustomerModel {
        return this._customer;
    }

    set customer(value: CustomerModel) {
        this._customer = value;
    }

    get line1(): string {
        return this._line1;
    }

    set line1(value: string) {
        this._line1 = value;
    }

    get line2(): string {
        return this._line2;
    }

    set line2(value: string) {
        this._line2 = value;
    }

    get line3(): string {
        return this._line3;
    }

    set line3(value: string) {
        this._line3 = value;
    }

    get line4(): string {
        return this._line4;
    }

    set line4(value: string) {
        this._line4 = value;
    }

    get file(): any {
        return this._file;
    }

    set file(value: any) {
        this._file = value;
    }

    get errors(): any[] {
        return this._errors;
    }

    set errors(value: any[]) {
        this._errors = value;
    }

    get speed(): boolean {
        return this._speed;
    }

    set speed(value: boolean) {
        this._speed = value;
    }

    get price(): string {
        return this._price;
    }

    set price(value: string) {
        this._price = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/letter.model.ts